module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_75.9f3a2e87.jpg";